'use strict';
/*
* Use this file to call functions in other files, on document ready, window.resize etc.
*/

var twentyninetimes = twentyninetimes || {};

// Document ready
document.addEventListener('DOMContentLoaded', function(){

    setTimeout(function() {
        svg4everybody(); // Fix SVG spritemap in IE/Edge
    });

    twentyninetimes.siteHeader.init();
    twentyninetimes.navigation.init();
    twentyninetimes.loadMore.init();
    twentyninetimes.filters.init();
    twentyninetimes.videoToggle.init();
    twentyninetimes.countrySelector.init();
    twentyninetimes.slider.init();
    twentyninetimes.caselist.init();
    twentyninetimes.joblist.init();
    twentyninetimes.featuredCases.init();
    twentyninetimes.mosaic.init();
    twentyninetimes.acForms.init();
    twentyninetimes.myPresentation.init();

    var splitSections = document.querySelectorAll('.is-style-split-sentence');
    if ( splitSections ) {
        splitSections.forEach((section => {
            var results = Splitting({ target: section, by: 'words' });
        }));
    }



// // Replace these variables with your own values
// // const siteUrl = 'http://jsworldmedia.local';
// const siteUrl = '';
// const customPostType = 'case';
// const pageNumber = 1; // Page number you want to retrieve
// const postsPerPage = 10; // Number of posts per page
// const offset = (pageNumber - 1) * postsPerPage;


// // Construct the API URL
// const apiUrl = `${siteUrl}/wp-json/wp/v2/${customPostType}?offset=${offset}&per_page=${postsPerPage}`;

// // Fetch data from the API
// fetch(apiUrl)
//   .then(response => response.json())
//   .then(data => {
//     // Handle the retrieved data
//     console.log(data); // Replace with your own logic
//   })
//   .catch(error => {
//     // Handle any errors
//     console.error(error); // Replace with your own error handling logic
//   });




    var inViewItems = document.querySelectorAll('.in-view-item, .is-style-split-sentence, .block-hero__images');
    if ( inViewItems ) {
        var test = (item) => {
            if ( !item.classList.contains('visible') ) {
                item.classList.add('visible');
            }

            if ( item.classList.contains('is-style-split-sentence') ) {
                var i = 0,
                    words = item.querySelectorAll('.word');

                function word_timeout(i) {
                    setTimeout(function() {
                        words[i].classList.add('visible');
                    }, i*40);
                }

                for (i = 0; i < words.length; i++) {
                     word_timeout(i);
                }
            }

            if ( item.classList.contains('block-hero__images') ) {
                var i = 0,
                    images = item.querySelectorAll('.media');

                function image_timeout(i) {
                    setTimeout(function() {
                        images[i].classList.add('visible');
                    }, i*40);
                }

                for (i = 0; i < images.length; i++) {
                     image_timeout(i);
                }
            }
        };
        twentyninetimes.inView.init(inViewItems, test, -100);
    }



    // var heroConfettiCanvas = document.getElementById('ctx');

    // if ( heroConfettiCanvas ) {
    //   var heroConfettiContainer = document.getElementById('blockHero');

    //     heroConfettiInit(heroConfettiCanvas, heroConfettiContainer, 50, 35);
    // }

    class TabsManual {
      constructor(groupNode) {
        this.tablistNode = groupNode;

        this.tabs = [];

        this.firstTab = null;
        this.lastTab = null;

        this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
        this.tabpanels = [];

        for (var i = 0; i < this.tabs.length; i += 1) {
          var tab = this.tabs[i];
          var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

          tab.tabIndex = -1;
          tab.setAttribute('aria-selected', 'false');
          this.tabpanels.push(tabpanel);

          tab.addEventListener('keydown', this.onKeydown.bind(this));
          tab.addEventListener('click', this.onClick.bind(this));

          if (!this.firstTab) {
            this.firstTab = tab;
          }
          this.lastTab = tab;
        }

        this.setSelectedTab(this.firstTab);
      }

      setSelectedTab(currentTab) {
        for (var i = 0; i < this.tabs.length; i += 1) {
          var tab = this.tabs[i];
          if (currentTab === tab) {
            tab.setAttribute('aria-selected', 'true');
            tab.removeAttribute('tabindex');
            this.tabpanels[i].classList.remove('is-hidden');
          } else {
            tab.setAttribute('aria-selected', 'false');
            tab.tabIndex = -1;
            this.tabpanels[i].classList.add('is-hidden');
          }
        }
      }

      moveFocusToTab(currentTab) {
        currentTab.focus();
      }

      moveFocusToPreviousTab(currentTab) {
        var index;

        if (currentTab === this.firstTab) {
          this.moveFocusToTab(this.lastTab);
        } else {
          index = this.tabs.indexOf(currentTab);
          this.moveFocusToTab(this.tabs[index - 1]);
        }
      }

      moveFocusToNextTab(currentTab) {
        var index;

        if (currentTab === this.lastTab) {
          this.moveFocusToTab(this.firstTab);
        } else {
          index = this.tabs.indexOf(currentTab);
          this.moveFocusToTab(this.tabs[index + 1]);
        }
      }

      /* EVENT HANDLERS */

      onKeydown(event) {
        var tgt = event.currentTarget,
          flag = false;

        switch (event.key) {
          case 'ArrowLeft':
            this.moveFocusToPreviousTab(tgt);
            flag = true;
            break;

          case 'ArrowRight':
            this.moveFocusToNextTab(tgt);
            flag = true;
            break;

          case 'Home':
            this.moveFocusToTab(this.firstTab);
            flag = true;
            break;

          case 'End':
            this.moveFocusToTab(this.lastTab);
            flag = true;
            break;

          default:
            break;
        }

        if (flag) {
          event.stopPropagation();
          event.preventDefault();
        }
      }

      // Since this example uses buttons for the tabs, the click onr also is activated
      // with the space and enter keys
      onClick(event) {
        this.setSelectedTab(event.currentTarget);
      }
    }

    // Initialize tablist

      var tablists = document.querySelectorAll('[role=tablist].contacts-tablist');
      for (var i = 0; i < tablists.length; i++) {
        new TabsManual(tablists[i]);
      }


    // Scroll functions
    window.onscroll = function () {
        // INSERT FUNCTIONS TO TRIGGER ON SCROLL

        twentyninetimes.siteHeader.checkScroll();
    };

    // Resize functions
    window.onresize = function () { 
        // INSERT FUNCTIONS TO TRIGGER ON WINDOW RESIZE
    };
    
});


